/*
  Only what <details> cannot do on its own: close when the pointer goes
  elsewhere, and close on Escape. Opening, closing and keyboard access are the
  element's own behaviour, so this file failing leaves the menu usable.
*/
(function () {
  'use strict';

  function setup(root) {
    if (root.accountReady) return;
    root.accountReady = true;

    document.addEventListener('click', function (event) {
      if (!root.open) return;
      if (root.contains(event.target)) return;
      root.open = false;
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !root.open) return;
      root.open = false;
      var toggle = root.querySelector('summary');
      toggle && toggle.focus();
    });
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-header-account]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
